import { TrackJS } from 'trackjs';
import { useDebugModeStore } from '~/stores/debug';

const PREFIX = '[Withlocals]';

class Logger {
  static log = (message, ...rest) => {
    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.log(PREFIX, message, ...rest);
    }
  };

  static logAnalytics = (message, ...rest) => {
    const { debugMode, logAnalytics } = useDebugModeStore.getState();
    if (!logAnalytics) return;
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.log('[Analytics]', message, ...rest);
    }
  };

  static warn = (message, ...rest) => {
    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.warn(PREFIX, message, ...rest);
    }
  };

  static group = (label: string) => {
    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.group(PREFIX, label);
    }
  };

  static groupCollapsed = (label: string) => {
    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.groupCollapsed(PREFIX, label);
    }
  };

  static groupEnd = () => {
    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.groupEnd();
    }
  };

  static error = (message, ...rest) => {
    const composedMessage = `${PREFIX} ${message} ${
      rest.length > 0 ? `[${JSON.stringify(rest)}]` : ''
    }`;
    if (TrackJS) {
      TrackJS.track(composedMessage);
    }

    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.error(composedMessage);
    }
  };
}

export default Logger;
